import React from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Mainpage from './Pages/Mainpage'
import Signin from './Pages/Signin'
import Signup from './Pages/Signup'
import Dashboard from './Admin/Dashboard'
import Portfolio from './Pages/Portfolio'
import FAQs from './Pages/FAQs'
import Blogs from './Pages/Blogs'
import Vision from './Pages/Vision'
import Mission from './Pages/Mission'
import Overview from './Pages/Overview'
import Contactus from './Pages/Contactus'
import Sliderupdate from './Admin/Sliderupdate'
import FAQSupdate from './Admin/FAQSupdate'
import Blogupdate from './Admin/Blogupdate'
import Portfolioupdate from './Admin/Portfolioupdate'
import Meetourteam from './Pages/Meetourteam'
import Clinicsolution from './Pages/Clinicsolution'
import Product from './Pages/Product'
import Hospitalmanagement from './Pages/Hospitalmanagement'
import Bookingfordemo from './Pages/Bookingfordemo'
import Clinicmanagement from './Pages/Clinicmanagement'
import SolutionforPharma from './Pages/SolutionforPharma'
import Patientapp from './Pages/Patientapp'
import Doctorsapp from './Pages/Doctorsapp'
import Booknow from './Pages/Booknow'
import Testimonialupdate from './Admin/Testimonialupdate'
import Bookappoinmentdetail from './Admin/Bookappoinmentdetail'
import Contactusdetails from './Admin/Contactusdetails'
import Teamupdate from './Admin/Teamupdate'
import Booknowdetails from './Admin/Booknowdetails'
import Clinicsolutionupdate from './Admin/Clinicsolutionupdate'
import Pricing from './Admin/Pricing'
import Plan from './Admin/Plan'
import Forgetpassword from './Pages/Forgetpassword'
import Category from './Admin/Category';
import ClientLogo from './Admin/ClientLogo';

import ProtectedRoute from './Components/ProtectedRoute';
import { AuthProvider } from "./contexts/AuthContext";
import OtherProductDetails from './Admin/OtherProductDetails';
import ClientEnquiry from './Admin/ClientEnquiry';

function App() {
  //
  return (
    <div>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route>
              <Route index path='/' element={<Mainpage />} />
              <Route index path='/home' element={<Mainpage />} />
              <Route path='/signin' element={<Signin />} />
              <Route path='/signup' element={<Signup />} />
              <Route path='/dashboard' element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path='/portfolio' element={<Portfolio />} />
              <Route path='/faqs' element={<FAQs />} />
              <Route path='/blogs' element={<Blogs />} />
              <Route path='/vision' element={<Vision />} />
              <Route path='/mission' element={<Mission />} />
              <Route path='/overview' element={<Overview />} />
              <Route path='/contactus' element={<Contactus />} />

              <Route path='/sliderupdate' element={
                <ProtectedRoute>
                  <Sliderupdate />
                </ProtectedRoute>
              } />
              <Route path='/faqsupdate' element={
                <ProtectedRoute>
                  <FAQSupdate />
                </ProtectedRoute>
              } />
              <Route path='/blogsupdate' element={
                <ProtectedRoute>
                  <Blogupdate />
                </ProtectedRoute>
              } />
              <Route path='/portfolioupdate' element={
                <ProtectedRoute>
                  <Portfolioupdate />
                </ProtectedRoute>
              } />
              <Route path='/meetourteam' element={<Meetourteam />} />
              <Route path='/clinicsolution' element={<Clinicsolution />} />
              <Route path='/product' element={<Product />} />
              <Route path='/hospitalmanagement' element={<Hospitalmanagement />} />
              <Route path='/bookingfordemo' element={<Bookingfordemo />} />
              <Route path='/clinicmanagement' element={<Clinicmanagement />} />
              <Route path='/solutionforpharma' element={<SolutionforPharma />} />
              <Route path='/patientapp' element={<Patientapp />} />
              <Route path='/doctorsapp' element={<Doctorsapp />} />
              <Route path='/booknow' element={<Booknow />} />
              <Route path='/testimonialupdate' element={
                <ProtectedRoute>
                  <Testimonialupdate />
                </ProtectedRoute>
              } />
              <Route path='/bookappoinmentdetail' element={
                <ProtectedRoute>
                  <Bookappoinmentdetail />
                </ProtectedRoute>
              } />
              <Route path='/contactusdetails' element={
                <ProtectedRoute>
                  <Contactusdetails />
                </ProtectedRoute>
              } />
              <Route path='/teamupdate' element={
                <ProtectedRoute>
                  <Teamupdate />
                </ProtectedRoute>
              } />
              <Route path='/booknowdetails' element={
                <ProtectedRoute>
                  <Booknowdetails />
                </ProtectedRoute>
              } />
              <Route path='/clinicsolutionupdate' element={
                <ProtectedRoute>
                  <Clinicsolutionupdate />
                </ProtectedRoute>
              } />
              <Route path='/otherproductdetails' element={
                <ProtectedRoute>
                  <OtherProductDetails />
                </ProtectedRoute>
              } />
              <Route path='/pricing' element={
                <ProtectedRoute>
                  <Pricing />
                </ProtectedRoute>
              } />
              <Route path='/plan' element={
                <ProtectedRoute>
                  <Plan />
                </ProtectedRoute>
              } />
              <Route path='/ClientLogo' element={
                <ProtectedRoute>
                  <ClientLogo />
                </ProtectedRoute>
              } />
              <Route path='/clientenquiry' element={
                <ProtectedRoute>
                  <ClientEnquiry />
                </ProtectedRoute>
              } />
              <Route path='/forgetpassword' element={<Forgetpassword />} />
              <Route path='/category' element={
                <ProtectedRoute>
                  <Category />
                </ProtectedRoute>
              } />
            </Route>
          </Routes>
        </BrowserRouter>

      </AuthProvider>
    </div>
  )
}

export default App
